import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '@shared/src/services/auth/auth.service';
import { LocalStorageService } from '@shared/src/services/local-storage.service';
import { SessionTokenRequest } from '@shared/src/models/session-token-request';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly authService: AuthService,
    private readonly localStorageService: LocalStorageService
  ) { }

  intercept(
    req: HttpRequest<SessionTokenRequest>,
    next: HttpHandler
  ): Observable<HttpEvent<SessionTokenRequest>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const idToken = this.localStorageService.getData('idToken');
        const errorMessage = error?.error?.errors;

        if (
          errorMessage &&
          errorMessage[0] &&
          (errorMessage[0]!.message as string).indexOf('expire') > -1
        ) {
          //console.log('Id token expires, requesting new one...');
          //this.authService.loginAgain();
          this.authService.logout();
          return next.handle(req);
        }

        if (error?.status === 401 && idToken) {
          console.log('Session token is not valid, requesting new one...');
          return this.authService.getSessionTokenAndRetry(idToken, req, next);
        }

        return throwError(() => error);
      })
    );
  }
}
